// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application a[data-v-46daf4e2] {\n  color: #fff;\n  text-decoration: none;\n}", ""]);
// Exports
module.exports = exports;
